const Required = () => <span style={{ color: "red", fontSize: "1.4em" }}>*</span>;
export default Required;
